import { createMuiTheme } from "@material-ui/core/styles";

// Reinaldo Alguz: #043852
const temaReinaldo = createMuiTheme({
  palette: {
    primary: {
      main: '#0567b4',
      light: '#00acea',
    },
  },
  typography: {
    fontSize: 20,
    htmlFontSize: 20
  },
  overrides: {
    MuiTypography: {
      gutterBottom: {
        marginBottom: 24,
      },
    },
  },
});

export default temaReinaldo;
